import { render, staticRenderFns } from "./SteffiAdminOnboarding.vue?vue&type=template&id=5039f4f8&scoped=true&"
import script from "./SteffiAdminOnboarding.vue?vue&type=script&lang=js&"
export * from "./SteffiAdminOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./SteffiAdminOnboarding.vue?vue&type=style&index=0&id=5039f4f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039f4f8",
  null
  
)

export default component.exports